<template>
    <div class="box-shadow-inside box-background box-ssjc mt20">
        <div class="box-title flex-between">
            <div class="box-title-text box-title-bg02">
                <p class="">业务统计（近12个月）</p>
            </div>
            <div class="box-title-right">
            </div>
        </div>
        <div class="water_list">
            <div class="water_level">
                <div class="wave_wrap level_1">
                    <div class="wave" :style="{top: (100 - rate1) + '%'}"></div>
                    <div class="wave_text"><span>{{rate1.toFixed(2)}}</span>%</div>
                </div>
                <div class="water_name">签约率</div>
            </div>
            <div class="water_level">
                <div class="wave_wrap level_2">
                    <div class="wave" :style="{top: (100 - rate2) + '%'}"></div>
                    <div class="wave_text"><span>{{rate2.toFixed(2)}}</span>%</div>
                </div>
                <div class="water_name">增贷率</div>
            </div>
            <div class="water_level">
                <div class="wave_wrap level_3">
                    <div class="wave" :style="{top: (100 - rate3) + '%'}"></div>
                    <div class="wave_text"><span>{{rate3.toFixed(2)}}</span>%</div>
                </div>
                <div class="water_name">逾期率</div>
            </div>
            <div class="water_level">
                <div class="wave_wrap level_4">
                    <div class="wave" :style="{top: (100 - rate4) + '%'}"></div>
                    <div class="wave_text"><span>{{rate4.toFixed(2)}}</span>%</div>
                </div>
                <div class="water_name">提前还款率</div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'MonitorLeftStatistics',
        data() {
            return {
                nowDate: "",
            }
        },
        /**
         * 业务统计（近12个月）：
         签约率=自营业务的签约贷款数（贷款申请日期）/总的已授信件数（进件日期）；
         增贷率=自营业务的增贷贷款数（贷款申请日期）/签约贷款数（贷款申请日期）;
         逾期率=自营业务的收取罚息复利的贷款数（应还款日）/放款贷款数（应还款日）(一个贷款多次预期的只算一次)（近12个月）
         提前还款率=自营业务的提前还款申请数（申请日期）/放款贷款数（贷款申请日期）。
         */
        computed: {

            rate1() {
                return 100 * (this.variables.FinancingCountsLast12Months||0) / (this.variables.ApplicationsLast12Months||1)
            },
            rate2() {
                return 100 * (this.variables.FinancingCountsLast12MonthsAdditional||0) / (this.variables.FinancingCountsLast12Months||1)
            },
            rate3() {
                return 100 * (this.variables.FinancingCountsLast12MonthsOverdue||0) / (this.variables.FinancingCountsLast12Months||1)
            },
            rate4() {
                return 100 * (this.variables.FinancingCountsLast12MonthsRepayAdv||0) / (this.variables.FinancingCountsLast12MonthsProcessing||1)
            }
        },
        mounted() {
        },
        components: {

        },
        props: {
            variables: {
                type: Object,
                default: ()=> ({})
            }
        },
        beforeDestroy() {
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor/partials/MonitorLeftStatistics.vue